<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <div
        style="display: grid; grid-template-rows: repeat(1, 1fr); grid-template-columns: repeat(6, 1fr); grid-column-gap: 0.75rem;"
      >
        <!--<b-form-group
          label="Tracking Number"
          class="mr-2"
        >{{ inventoryDetails.trackingNumber }} - {{ inventoryDetails.shippingMethodName }}</b-form-group>-->
        <b-form-group label="Tracking Number" class="mr-2">{{ inspectionDetails.trackingNumber || '-'}}</b-form-group>
        <b-form-group label="No. of Boxes Rec.">
          <b-form-input type="text" v-model="model.shipmentDetails_NumberBoxes"></b-form-input>
        </b-form-group>
        <b-form-group label="Cond. of Boxes Rec." style="grid-row: 1; grid-column: 3/5">
          <b-form-radio-group
            :options="['Good', 'Fair', 'Poor','Damaged']"
            v-model="model.shipmentDetails_Condition"
          ></b-form-radio-group>
        </b-form-group>

        <b-form-group label="Box Fill Material Type"  style="grid-row: 1; grid-column: 5">
          <b-form-input type="text" v-model="model.shipmentDetails_BoxMaterialUsed"></b-form-input>
        </b-form-group>
        <b-form-group label="Box Weight">
          <b-form-input type="text" v-model="model.shipmentDetails_BoxWeight"></b-form-input>
        </b-form-group>
        
        
        <b-form-group
          label="Did the parts show any sign of damage as result of shipping?"
          style="grid-row: 2; grid-column: 1/3"
        >
          <b-form-radio-group :options="['Yes', 'No']" v-model="model.shipmentDetails_Damaged"></b-form-radio-group>
        </b-form-group>
        <b-form-group label="ESD Compliant" style="grid-row: 2; grid-column: 3">
          <b-form-radio-group :options="['Yes', 'No']" v-model="model.shipmentDetails_ESDCompliant">
          </b-form-radio-group>  
        </b-form-group>
        <b-form-group label="Shipping Damage Notes" style="grid-row: 2; grid-column: 4/7">
          <b-textarea type="text" v-model="model.shipmentDetails_Notes"></b-textarea>
        </b-form-group>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'aegisShipment',
  components: {},
  props: {
    inventoryDetails: {
      type: Object,
      default: () => {},
    },
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        shipmentDetails_NumberBoxes: this.inspectionDetails[FIELDS.SHIPMENT_DETAILS__NUMBER_BOXES] || '',
        shipmentDetails_Condition: this.inspectionDetails[FIELDS.SHIPMENT_DETAILS__CONDITION] || '',
        shipmentDetails_ShippedIn: this.inspectionDetails[FIELDS.SHIPMENT_DETAILS__SHIPPED_IN] || '',
        shipmentDetails_ShippedInOther: this.inspectionDetails[FIELDS.SHIPMENT_DETAILS__SHIPPED_IN_OTHER] || '',
        shipmentDetails_Damaged: this.inspectionDetails[FIELDS.SHIPMENT_DETAILS__DAMAGED] || '',
        shipmentDetails_Notes: this.inspectionDetails[FIELDS.SHIPMENT_DETAILS__NOTES] || '',
        shipmentDetails_BoxMaterialUsed: this.inspectionDetails[FIELDS.SHIPMENT_DETAILS__BOX_MATERIAL_USED] || '',
        shipmentDetails_BoxWeight: this.inspectionDetails[FIELDS.SHIPMENT_DETAILS__BOX_WEIGHT] || '', 
        shipmentDetails_ESDCompliant: this.inspectionDetails[FIELDS.SHIPMENT_DETAILS__ESD_COMPLIANT] || '',
      },
    };
  },
  computed: {
    fullTrackingNumber(){
      // console.log(this.inventoryDetails, this.inspectionDetails, "Test")
      // console.log('this.inventoryDetails.trackingNumber :', this.inventoryDetails);

      // return (this.inventoryDetails.trackingNumber ? (this.inventoryDetails.trackingNumber.concat(this.inventoryDetails.shippingMethodName)) : this.inventoryDetails.shippingMethodName);
      // return this.inspectionDetails.tracking ? this.inspectionDetails.trackingNUmber "-";
    }
  },
};
</script>